

$(function () {
$('#confirm-delete').on('show.bs.modal', function (e) {
    $(this).find('.btn-yes').attr('href', $(e.relatedTarget).data('href'));
});

$('#confirm-disable').on('show.bs.modal', function (e) {
    $(this).find('.btn-yes').attr('href', $(e.relatedTarget).data('href'));
});

$('#confirm-enable').on('show.bs.modal', function (e) {
    $(this).find('.btn-yes').attr('href', $(e.relatedTarget).data('href'));
});

    if ($('.dest-type').val() == 1) {
        $('.phone').show();
        $('.task-queue-id').hide();
        $('.ring-group-id').hide();
    } else if ($('.dest-type').val() == 2) {
        $('.phone').hide();
        $('.task-queue-id').show();
        $('.ring-group-id').hide();
    } else if ($('.dest-type').val() == '3') {
        $('.phone').hide();
        $('.task-queue-id').hide();
        $('.ring-group-id').show();
    } else {
        $('.phone').hide();
        $('.task-queue-id').hide();
        $('.ring-group-id').hide();
    }


    if ($('.contact-type').val() == 0) {
        $('.phone').hide();
    } else if ($('.contact-type').val() == 1) {
        $('.phone').show();
    }

    if ($('.time-route-items').find('.item').length == 0)
        $('#submit-time-route-delete').hide();

    $('.dest-type').change(function () {
        if ($(this).val() == '1') {
            $('.phone').show();
            $('.task-queue-id').hide();
            $('.ring-group-id').hide();
        } else if ($(this).val() == '2') {
            $('.phone').hide();
            $('.task-queue-id').show();
            $('.ring-group-id').hide();
        } else if ($(this).val() == '3') {
            $('.phone').hide();
            $('.task-queue-id').hide();
            $('.ring-group-id').show();
        } else {
            $('.phone').hide();
            $('.task-queue-id').hide();
            $('.ring-group-id').hide();
        }
    });

    $('.contact-type').change(function () {
        if ($(this).val() == 0) {
            $('.phone').hide();
        } else if ($(this).val() == 1) {
            $('.phone').show();
        }
    });

    if ($('.abandoned').length > 0 && $('.answer-rate').length > 0) {
        $.ajax({
            type: 'GET',
            url: '/dropped-call-count',
            success: function (droppedCallCount) {
                $('.abandoned')[0].innerHTML = window.abandoned - droppedCallCount;
                $('.answer-rate')[0].innerHTML = parseFloat(parseInt(window.answered) != 0 ? (parseInt(window.answered) / ((parseInt(window.abandoned) - parseInt(droppedCallCount)) + parseInt(window.answered))) * 100 : 0).toFixed(2) + '  %';
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    for (var i = 1; i <= 3; i++) {
        if ($('.dest-type-' + i).val() == 1) {
            $('.phone-' + i).show();
            $('.task-queue-id-' + i).hide();
        } else if ($('.dest-type-' + i).val() == 2) {
            $('.phone-' + i).hide();
            $('.task-queue-id-' + i).show();
        }

        $('.dest-type-' + i).change(function () {
            if ($(this).val() == '1') {
                $('.phone-' + $(this).data('value')).show();
                $('.task-queue-id-' + $(this).data('value')).hide();
            } else if ($(this).val() == '2') {
                $('.phone-' + $(this).data('value')).hide();
                $('.task-queue-id-' + $(this).data('value')).show();
            }
        });
    }

    function checkRemoveSelectedTimesBtn() {
        if (!($("input[name='id']:checked").length > 0))
            $('#submit-time-route-delete').prop('disabled', true);
        else
            $('#submit-time-route-delete').prop('disabled', false);
    }

    checkRemoveSelectedTimesBtn();

    $("input[name='id']").change(function () {
        checkRemoveSelectedTimesBtn();
    });

    $('#submit-time-route-delete').click(function () {
        var values = new Array();
        $.each($("input[name='id']:checked"),
            function () {
                values.push($(this).val());
            }
        );

        $.ajax({
            type: 'GET',
            url: '/admin/time-route-item/delete',
            data: {'values': values},
            success: function (result) {
                window.location.reload();
            }
        });
    });

    function clearErrorMsgs(event) {
        if ($(event.target).find('#store').hasClass('has-error'))
            $(event.target).find('#store').removeClass('has-error');

        if ($(event.target).find('#result').hasClass('has-error'))
            $(event.target).find('#result').removeClass('has-error');

        $(event.target).find('#store').find('#select-store').find('span').html('');
        $(event.target).find('#result').find('#select-result').find('span').html('');

        $(event.target).find('#inquiryId').removeClass('has-error');
        $(event.target).find('#eventId').removeClass('has-error');
        $(event.target).find('#inquiryId').find('.help-block').html('');
        $(event.target).find('#eventId').find('.help-block').html('');
    }

    function displaySuccessAgent(event, data) {
        clearErrorMsgs(event);

        $('.feedback').hide();

        if ($('.wrapup').css('display') == 'block') {
            var nextActivitySid = 'WA5ddb49c1f8c039d6489a35edce474916';
            worker.update("ActivitySid", nextActivitySid);
        }

        $('.wrapup > .change-activity').show();
        $(event.target).find("input[type=text], textarea, select").val("");
    }


    function displaySuccessAdmin(event, data) {
        clearErrorMsgs(event);

        $('td > #' + $(event.target).find("input[name='call_sid']").val()).html('<p class=\'alert alert-success\'>Feedback has been successfully updated!' +
            '<a href=\'#\' class=\'close\' data-dismiss=\'alert\' aria-label=\'close\'>×</a></p>');
    }

    function submitFeedback(event) {
        event.preventDefault();
        $.ajax({
            type: 'POST',
            url: '/worker/add-call-feedback',
            data: {
                callSid: $(event.target).find("input[name='call_sid']").val(),
                store: $(event.target).find("select[name='store_id'] option:selected").val(),
                result: $(event.target).find("select[name='feedback_option_id'] option:selected").val(),
                note: $(event.target).find("textarea[name='note']").val(),
                inquiryId: $(event.target).find("input[name='inquiry_id']").val(),
                eventId: $(event.target).find("input[name='event_id']").val()
            },
            success: function (data) {
                if ($(event.target).find('#agent-feedback-sumit').length > 0)
                    displaySuccessAgent(event, data);
                else
                    displaySuccessAdmin(event, data);
            },
            error: function (data) {
                var errors = data.responseJSON;
                clearErrorMsgs(event);

                $.each(errors, function (index, value) {
                    $(event.target).find('#' + index).addClass('has-error');
                    $(event.target).find('#' + index).find('.help-block').html('<strong>' + value + '</strong>');
                });
            }
        });
    }

    $('#agent-form').submit(function (event) {
        submitFeedback(event);
    });

    $('.feedback-form').submit(function (event) {
        submitFeedback(event);
    });

});

var callHistoryAudit = function (_this) {
    $.ajax({
        type: 'POST',
        url: '/admin/call/audit',
        data: {
            callId: $(_this).attr("data-id"),
            audited: $(_this).is(':checked')
        },
        success: function (data) {
            var auObj = $('#au-' + $(_this).attr("data-id")).find('span');
            if (auObj.hasClass("audited")) {
                auObj.removeClass();
                auObj.addClass("glyphicon glyphicon-remove-sign not-audited");
                auObj.attr("title", "Not Audited");
            } else {
                auObj.removeClass();
                auObj.addClass("glyphicon glyphicon-ok-sign audited");
                auObj.attr("title", "Audited");
            }
            $(_this).attr("disabled", false);
            $('#au-' + $(_this).attr("data-id")).find('img').hide();
            $('#au-' + $(_this).attr("data-id")).find('span').show();
        },
        error: function (data) {
            $(_this).attr("checked", !$(_this).is(':checked')); // undo check/unckeck
            $(_this).attr("disabled", false);
            $('#au-' + $(_this).attr("data-id")).find('img').hide();
            $('#au-' + $(_this).attr("data-id")).find('span').show();
            alert("Some error occurred. Please try again.");
        },
        beforeSend: function () {
            $(_this).attr("disabled", true);
            $('#au-' + $(_this).attr("data-id")).find('span').hide();
            $('#au-' + $(_this).attr("data-id")).find('img').show();
        }
    });
}

function validateIvrUpdate(_this, storeId) {
    var emailValue = $('#store-edit-form input[name="store_email"]').val();
    var ivrEnabled = $('#store-edit-form input[name="ivr_enabled"]').is(':checked');
    var automaticIvrEnabled = $('#store-edit-form input[name="automatic_ivr_enabled"]').is(':checked');
    _this = $(_this);

    if(($('#store-edit-form input[name="drop_call_alert"]').is(':checked') && ($.trim(emailValue)=="")) || ($.trim(emailValue)!="" && !isEmail(emailValue)) )
    {
        alert('Please provide a proper email address');
        return false;
    }


    if (!automaticIvrEnabled) {
        if (confirm('There MUST be hard-coded IVR for this store if automatic IVR is disabled otherwise calls will be dropped. You should confirm it with your dev team. Do you want to continue?')) {
            $('#store-edit-form').submit();
        }
        return;
    }

    $.ajax({
        type: 'POST',
        url: '/admin/store/validate-ivr-update',
        data: {
            storeId: storeId
        },
        success: function (data) {
            if (data) {
                console.log(ivrEnabled);
                console.log(automaticIvrEnabled);
                console.log(data);
                _this.text('Update');
                _this.prop('disabled', false);

                if (!ivrEnabled && !data.campaignWithNoIvr) {
                    alert('You MUST define NO IVR campaign before disabling IVR option for this store. Please go to Admin >> Campaigns and add NO IVR campaign for this store.');
                    return;
                }

                if (ivrEnabled && !data.campaignWithIvr) {
                    alert('You MUST define campaign with IVR before enabling IVR option for this store. Please go to Admin >> Campaigns and add campaign with IVR for this store.');
                    return;
                }

                if (automaticIvrEnabled && (!data.autoIvrWithForWelcome || !data.autoIvrWithForWait || !data.autoIvrWithForQa)) {
                    var confirmText = 'Following IVR has not been defined for the store: \n\n';
                    confirmText += data.autoIvrWithForWelcome ? '' : 'Welcome\n';
                    confirmText += data.autoIvrWithForWait ? '' : 'Wait\n';
                    confirmText += data.autoIvrWithForQa ? '' : 'QA\n';
                    confirmText += '\nYou can update it on Admin >> Store IVR Settings. Do you want to continue?';
                    if (!confirm(confirmText)) {
                        return;
                    }
                }
                $('#store-edit-form').submit();
            } else {
                alert("Some error occurred. Please try again.");
            }
        },
        error: function (data) {
            alert("Some error occurred. Please try again.");
            _this.text('Update');
            _this.prop('disabled', false);
        },
        beforeSend: function () {
            _this.text('Wait ...');
            _this.prop('disabled', true);
        }
    });

}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}